module.exports = __webpack_public_path__ + "h5/img/bb3.d30a98f7.png";